import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import About from '../components/About.vue'
import Contact from '../components/Contact.vue'
import News from '../components/News.vue'
import NewDetail from '../components/NewDetail.vue'
import Service from '../components/Service.vue'
import ServiceDetail from '../components/ServiceDetail.vue'
import Products from '../components/Products.vue'
import ProductDetail from '../components/ProductDetail.vue'
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push
// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace
// 修改原型对象中的push函数
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/About',
    name: 'About',
    component: About
  },
  {
    path: '/Products',
    name: 'Products',
    component: Products
  },
  {
    path: '/ProductDetail',
    name: 'ProductDetail',
    component: ProductDetail
  },
  {
    path: '/News',
    name: 'News',
    component: News
  },
  {
    path: '/NewDetail',
    name: 'NewDetail',
    component: NewDetail
  },
  {
    path: '/Service',
    name: 'Service',
    component: Service
  },
  {
    path: '/ServiceDetail',
    name: 'ServiceDetail',
    component: ServiceDetail
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: Contact
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    // x代表横坐标，y代表纵坐标
    return { x: 0, y: 0 }
  }
})
export default router
